import { IAppState } from '../../../AppModulesWrapper';

import { EPublishTermsAvailableMoneySources } from '../../types/reducers/publishTerms';

export const selectAvailableMoneySources = (state: IAppState): EPublishTermsAvailableMoneySources => {
  return state.servicePickerWidget.publishTerms.availableMoneySources;
};
